import { ComponentType, useRef } from "react";
import { Tooltip } from "../Tooltip";
import { InfoIcon } from "@src/assets";

type Props = {
  tooltipText: string;
  id: string;
  icon?: ComponentType<any>;
  iconClassName?: string;
};

export const IconWithTooltip = ({
  tooltipText,
  id,
  icon: Icon = InfoIcon,
  iconClassName,
}: Props) => {
  const tooltipTriggerRef = useRef<SVGSVGElement>(null);

  return (
    <>
      <Icon
        ref={tooltipTriggerRef}
        className={`opacity-60 hover:opacity-20 cursor-pointer ${iconClassName}`}
      />

      <Tooltip id={id} text={tooltipText} triggerRef={tooltipTriggerRef} />
    </>
  );
};
